import { ClientShipmentFolder } from "@redotech/redo-model/views/folders";
import { ClientShipmentView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const updateShipmentViewOrdering = {
  name: "updateShipmentViewOrdering" as const,
  input: z.object({
    views: z.array(ClientShipmentView),
    folders: z.array(ClientShipmentFolder),
  }),
  output: z.object({}),
};
